import React from 'react';
import { StyledHeaderContainer, StyledTitle } from './ResetPasswordStyles';

interface HeaderProps {
    title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
    return (
        <StyledHeaderContainer>
            <StyledTitle className="header-styled">{title}</StyledTitle>
        </StyledHeaderContainer>
    );
};

export default Header;
